import { render } from "./Notifications.vue?vue&type=template&id=2e7cd6df&ts=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e7cd6df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e7cd6df', __exports__)) {
    api.reload('2e7cd6df', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=2e7cd6df&ts=true", () => {
    api.rerender('2e7cd6df', render)
  })

}


export default __exports__